/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

function SellerResearch({ color, size }) {
  return (
    // <svg
    //     width={size}
    //     height={size}
    //     version="1.1"
    //     fill={colors[color] ? colors[color].main : colors.dark.main}
    //     fillRule="nonzero"
    //
    //     id="fi_3875874" viewBox="0 0 512 512"  xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><g fillRule="evenodd"><path d="m193.851 200.162 78.918-45.553v91.107l-78.918 45.554zm-8.314 91.11-78.871-45.556v-91.109l78.871 45.556zm99.039 23.18a149.345 149.345 0 0 0 54.7-101.239 150.367 150.367 0 0 0 -244.417-132.149 149.339 149.339 0 0 0 -54.7 101.243 150.42 150.42 0 0 0 244.417 132.145zm17.11 21.084a176.939 176.939 0 1 0 -62.321 32.682 177.024 177.024 0 0 0 62.321-32.682zm98.923 22.448a12.445 12.445 0 0 1 8.863-3.72 12.307 12.307 0 0 1 8.618 3.485l78.032 75.711a12.46 12.46 0 0 1 .271 17.475l-36.044 37.134a12.406 12.406 0 0 1 -17.508.26l-77.985-75.707a12.336 12.336 0 0 1 -3.759-8.667v-.079a12.283 12.283 0 0 1 3.489-8.73z" fill="#9bc9ff"></path><path d="m197.69 284.62v-82.241l71.239-41.12v82.241zm-87.185-123.361 71.192 41.12v82.241l-71.192-41.12v-82.24zm79.212-54.976-71.238 41.117 71.238 41.12 71.239-41.12-71.239-41.12zm91.242 34.189-87.232-50.358a8.038 8.038 0 0 0 -8.02 0l-87.232 50.358a8.017 8.017 0 0 0 -3.963 6.931v100.715a8.009 8.009 0 0 0 3.963 6.926l87.232 50.356a8.01 8.01 0 0 0 8.02 0l87.232-50.357a8.007 8.007 0 0 0 3.963-6.926v-100.717a8.015 8.015 0 0 0 -3.963-6.931zm212.678 307.789-36.044 37.139a8.57 8.57 0 0 1 -12.077.179l-77.985-75.707a8.509 8.509 0 0 1 -.189-12.049l36-37.133a8.6 8.6 0 0 1 6.133-2.581 8.46 8.46 0 0 1 5.944 2.4l78.033 75.711a8.556 8.556 0 0 1 2.548 5.98 8.433 8.433 0 0 1 -2.359 6.058zm-438.707-140.949c60.388 74.329 170.029 85.656 244.334 25.245 1.133-.915 2.218-1.84 3.35-2.774v-.028c71.333-60.949 81.386-168.355 21.886-241.555a173.688 173.688 0 0 0 -244.33-25.246c-74.352 60.411-85.67 170.029-25.24 244.358zm329.349 50.088-44.679-43.332a186.439 186.439 0 0 1 -20.145 22.06l44.016 42.692zm120.3 67.332-78.029-75.71a24.54 24.54 0 0 0 -30.76-2.736l-46.847-45.433c43.4-67.148 41.092-157.418-12.031-222.741a189.666 189.666 0 0 0 -266.838-27.57c-81.193 65.969-93.554 185.687-27.552 266.858a189.89 189.89 0 0 0 264.81 29.2l45.385 44.059a24.732 24.732 0 0 0 -3.774 13.45 24.365 24.365 0 0 0 7.407 17.23l78.032 75.711a24.554 24.554 0 0 0 34.676-.519l36.042-37.131a24.6 24.6 0 0 0 -.519-34.671zm-177.385-212.771a138.208 138.208 0 1 0 -274.953-28.406 138.233 138.233 0 0 0 224.614 121.464 137.146 137.146 0 0 0 50.339-93.058zm-17.786-111.461c-53.642-65.994-150.97-76.043-216.971-22.416a154.225 154.225 0 0 0 194.563 239.348 154.3 154.3 0 0 0 22.408-216.932z"></path></g></svg>
    //

    <svg

        width={size}
        height={size}
        version="1.1"
        fill={colors[color] ? colors[color].main : colors.dark.main}
        fillRule="nonzero"

        id="fi_2282161" enableBackground="new 0 0 512.011 512.011" viewBox="0 0 512.011 512.011" xmlns="http://www.w3.org/2000/svg"><path d="m373.156 351.95c-9.27 4.16-16.94 11.71-21.16 21.21-.36-.3-25.92-25.88-32.87-32.83 7.62-6.5 14.72-13.6 21.22-21.22 6.94 6.93 32.46 32.45 32.81 32.84z" fill="#003481"></path><circle cx="195.516" cy="195.5" fill="#0097f0" r="195.5"></circle><path d="m391.016 195.5c0 107.63-87.43 195.23-195 195.5v-391c107.57.27 195 87.87 195 195.5z" fill="#0052c2"></path><circle cx="195.516" cy="195.5" fill="#e0f4ff" r="165.5"></circle><path d="m361.016 195.5c0 91.09-73.97 165.23-165 165.5v-331c91.03.27 165 74.41 165 165.5z" fill="#b8e0f5"></path><path d="m498.303 432.074-75.001-75c-18.297-18.298-47.912-18.3-66.213 0-18.255 18.255-18.255 47.958 0 66.213l75.001 75c18.297 18.298 47.912 18.3 66.213 0 18.255-18.255 18.255-47.958 0-66.213z" fill="#fe9022"></path><path d="m286.016 121h-180c-8.284 0-15 6.716-15 15v110c0 30.327 24.673 55 55 55h100c30.327 0 55-24.673 55-55v-110c0-8.284-6.716-15-15-15z" fill="#fdbf00"></path><path d="m301.016 136v110c0 30.33-24.67 55-55 55h-50v-180h90c8.28 0 15 6.72 15 15z" fill="#fe9022"></path><path d="m196.016 61c-33.084 0-60 26.916-60 60v30c0 8.284 6.716 15 15 15s15-6.716 15-15v-30c0-16.542 13.458-30 30-30s30 13.458 30 30v30c0 8.284 6.716 15 15 15s15-6.716 15-15v-30c0-33.084-26.916-60-60-60z" fill="#0052c2"></path><path d="m256.016 121v30c0 8.28-6.72 15-15 15s-15-6.72-15-15v-30c0-16.54-13.46-30-30-30v-30c33.08 0 60 26.92 60 60z"></path></svg>
  );
}

// Setting default values for the props of Office
SellerResearch.defaultProps = {
  color: "dark",
  size: "16px",
};

// Typechecking props for the Office
SellerResearch.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SellerResearch;
